





























































































import { Component, Vue, Watch } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import ResearchCenter from "@/models/research/ResearchCenter/reseachCenter.model";
import { BTableColumnType } from "@/enums/BTableColumnType";
import { PermissionValue } from "../../../enums/PermissionValue";
import UserBasicInformationComponent from "@/components/user-basic-information/userBasicInformation.vue";
import ResearchCenterBasicInformationComponent from "@/components/research-center-basic-information/researchCenterBasicInformation.vue";

@Component({
  components: {
    UserBasicInformationComponent,ResearchCenterBasicInformationComponent
  }
})
export default class ResearchCenterTable extends GenericBTable<ResearchCenter> {
  name = "";
  
  created() {
    this.permissionValue = PermissionValue.CENTROINVESTIGACIONES;
    this.tableConfig.controller = "ResearchCenters/GetBasicReserachCenter";
  }

  mounted() {
    this.formatColumns();
  }

  formatColumns() {
    let name = new BTableColumn("name", "table.name", true);
    name.customTemplate = true;
    name.width = '50%';
    let adminCenter = new BTableColumn("adminCenter", "table.admin", true);
    // researchType.customTemplate = true;
    this.tableConfig.enableDefaultColumns = false;
     adminCenter.customTemplate = true;
    this.tableConfig.insertColumns(name, adminCenter);
    this.tableConfig.activeActions = this.permissionAccess.write;
    this.tableConfig.actions.customTemplate = this.permissionAccess.write;
  }

  searcherLabel(event: any) {
    if (event.keyCode === 13) {
      this.tableConfig.whereParams = `contains(Abbreviation, '${this.name}') or contains(Name, '${this.name}')`;
      this.tableConfig.reload();
    }
  }
}
